import React from 'react';
import { ServicePage } from '../ServicePage';

const CONFIG = {
  title: 'Réparation Ordinateur & PC Villeurbanne / Lyon — Mac, Windows | PHONELAB 69',
  metaDescription: '✅ Réparation PC portable & Mac Villeurbanne / Lyon. Windows, MacBook, iMac. Écran, clavier, batterie, SSD, micro-soudure. Diagnostic GRATUIT. ☎ 04 26 00 82 10',
  icon: '💻',
  badge: 'Réparation PC & Mac — Villeurbanne / Lyon',
  h1: 'Réparation Ordinateur\nVilleurbanne & Lyon',
  subtitle: 'PC portables, MacBook, iMac, tours Windows — diagnostic gratuit, devis fixe avant travaux, réparation express ou sous 48h selon la panne.',
  stats: [
    { icon: '🆓', label: 'Diagnostic GRATUIT' },
    { icon: '💰', label: 'Devis fixe avant travaux' },
    { icon: '🛡️', label: 'Garantie jusqu\'à 12 mois' },
    { icon: '⚡', label: 'Express ou 24-48h' },
  ],
  servicesTitle: 'Réparations ordinateurs disponibles à Villeurbanne',
  services: [
    { icon: '📺', name: 'Remplacement écran PC portable', models: 'Toutes marques : Asus, HP, Lenovo, Dell, Acer', duration: '1-3h' },
    { icon: '🍎', name: 'Réparation MacBook', models: 'MacBook Air & Pro — écran, batterie, clavier, SSD', duration: '24-48h' },
    { icon: '⌨️', name: 'Remplacement clavier', models: 'PC portable & MacBook — toutes marques', duration: '1-2h' },
    { icon: '🔋', name: 'Remplacement batterie PC', models: 'Batterie gonflée ou en fin de vie', duration: '30-60 min' },
    { icon: '💾', name: 'Upgrade SSD / RAM', models: 'Remplacement disque dur → SSD, ajout RAM', duration: '1-2h' },
    { icon: '🌡️', name: 'Nettoyage & ventilation', models: 'PC qui chauffe, ventilo bruyant, lenteur', duration: '1h' },
    { icon: '🦠', name: 'Suppression virus & malware', models: 'Réinstallation Windows si nécessaire', duration: '2-4h' },
    { icon: '🔧', name: 'Micro-soudure carte mère', models: 'Problèmes d\'alimentation, chip GPU/CPU', duration: '24-72h' },
    { icon: '💿', name: 'Récupération de données', models: 'Disque dur HS, SSD défaillant, Windows planté', duration: '24-72h' },
  ],
  guarantee: {
    duration: 'Garantie 6-12 mois',
    label: 'Pièces premium ou d\'origine',
    speed: 'Express ou 24-48h',
  },
  faq: [
    {
      q: 'Combien coûte la réparation d\'un ordinateur à Villeurbanne ?',
      a: 'Le prix dépend de la panne et du modèle. PHONELAB 69 propose un diagnostic gratuit et un devis fixe AVANT de commencer les travaux — aucune mauvaise surprise. Appelez le 04 26 00 82 10 ou passez au 6 Rue Paul Verlaine.',
    },
    {
      q: 'Réparez-vous les MacBook à Villeurbanne ?',
      a: 'Oui, PHONELAB 69 répare tous les modèles MacBook Air et MacBook Pro (Intel et M1/M2/M3). Écran, batterie, clavier papillon, SSD, micro-soudure carte logique. Devis gratuit sous 24h.',
    },
    {
      q: 'Mon PC portable chauffe et s\'éteint tout seul — que faire ?',
      a: 'Ce symptôme indique un refroidissement défaillant (ventilateur bloqué, pâte thermique desséchée). Un nettoyage professionnel avec remplacement de pâte thermique résout 90% des cas. Diagnostic gratuit chez PHONELAB 69 à Villeurbanne.',
    },
    {
      q: 'Pouvez-vous récupérer mes données sur un disque dur cassé ?',
      a: 'Oui, PHONELAB 69 propose la récupération de données sur disques durs mécaniques et SSD défaillants. Diagnostic gratuit. Le tarif dépend du niveau d\'endommagement. Résultat non garanti pour les pannes physiques graves.',
    },
    {
      q: 'Le passage au SSD vaut-il vraiment le coup sur un vieux PC ?',
      a: 'Absolument. Remplacer un disque dur mécanique par un SSD est la meilleure amélioration possible sur un PC de plus de 3 ans. Windows démarre en 10 secondes au lieu de 2 minutes, les logiciels s\'ouvrent instantanément. Coût modéré, résultat immédiat et spectaculaire.',
    },
    {
      q: 'Réparez-vous les charnières de PC portable à Villeurbanne ?',
      a: 'Oui, et c\'est une spécialité rare. Une charnière abîmée qui "force" à l\'ouverture exerce une tension sur les nappes vidéo et peut finir par couper le rétroéclairage de l\'écran. PHONELAB 69 répare ou remplace les charnières avant que la panne s\'aggrave.',
    },
  ],
  extraSections: [
    {
      id: 'maintenance',
      title: 'Boostez les performances de votre ordinateur',
      subtitle: 'Avant d\'en changer, pensez à l\'optimisation — souvent plus rentable qu\'un nouvel appareil.',
      items: [
        {
          icon: '🌡️',
          name: 'Nettoyage interne & pâte thermique',
          desc: 'Extraction de la poussière accumulée et remplacement de la pâte thermique pour éliminer les surchauffes du processeur. Résultat immédiat sur la température et le bruit du ventilateur.',
        },
        {
          icon: '💾',
          name: 'Passage au SSD (upgrade radical)',
          desc: 'Remplacer le disque dur mécanique par un SSD transforme radicalement la vitesse : Windows démarre en 10 secondes, les logiciels s\'ouvrent instantanément. La meilleure amélioration possible sur un PC de plus de 3 ans.',
        },
        {
          icon: '🧠',
          name: 'Ajout de RAM',
          desc: 'Un PC qui "rame" sur Chrome ou Excel manque souvent de mémoire vive. Doubler la RAM (de 4 Go à 8 Go, ou de 8 Go à 16 Go) améliore le multitâche de façon significative.',
        },
        {
          icon: '🦠',
          name: 'Suppression virus & réinstallation Windows',
          desc: 'Nettoyage complet des malwares, ransomwares et bloatwares. Réinstallation propre de Windows 11 si nécessaire — vos fichiers sauvegardés avant toute intervention.',
        },
      ],
    },
  ],
  ctaTitle: 'Votre ordinateur diagnostiqué aujourd\'hui',
  ctaSubtitle: 'Diagnostic gratuit · Devis fixe · Sans mauvaise surprise',
};

export default function OrdinateurPage() {
  return <ServicePage config={CONFIG} />;
}
